module.exports = __webpack_public_path__ + "static/media/19.432d386c.mp3";